import React from 'react';
import { TextField } from '@mui/material';

import { NumericFormat } from 'react-number-format';
const AmountInput = ({ label, value, onChange, ...props }) => {

  // Handle changes in the input field
  const handleInputChange = (e) => {
    const newValue = e.value;
    
    // Validate and allow only numbers and decimal points
    if (/^\d*\.?\d*$/.test(newValue)) {
      onChange(newValue); // Update the state if valid
    } else {
      // Optionally, show feedback or handle invalid characters
      console.warn("Invalid input: only numbers and one decimal point are allowed");
    }
  };

  return (
    <NumericFormat
    customInput={TextField} // Use TextField as the input component
    fullWidth
    label={label} // Pass the label to the TextField
    value={value} // Pass the value
    onValueChange={handleInputChange} // Handle value change
    decimalScale={2} // Limit to 2 decimal places
    fixedDecimalScale={true}
    allowNegative={false} // Disallow negative values
    thousandSeparator={true} 
       prefix="₹" // Add a dollar sign as the prefix
    InputLabelProps={{ shrink: true }} // Ensure the label shrinks properly
    {...props} // Pass any additional props
  />

  
  );
};

export default AmountInput;
